<template>
  <label class="ux-field-title" v-if="showLabel"
    >{{ label }}
    <span class="ux-required-marker" v-if="required">*</span></label
  >
  <div class="ux-field-description" v-if="showDescription">
    {{ description }}
  </div>

  <template v-if="multiValue">
    <div class="select-tags" v-if="model && model.length">
      <div class="select-tag" v-for="(val, index) in modelDisplay" :key="index">
        <flex-row gap center>
          <flex-cell>{{ val }}</flex-cell>
          <flex-cell shrink>
            <a @click="removeValue(index)"><ux-icon icon="fa-times" /></a>
          </flex-cell>
        </flex-row>
      </div>
    </div>
    <template v-if="canAddValue">
      <value-search
        :options="options"
        :async-options="shouldPreload ? undefined : asyncOptionsURL"
        :server-filtered="field.serverFiltered"
        v-model="model"
        :multiple="true"
        :placeholder="placeholder"
        :list="false"
      />
    </template>
  </template>

  <template v-else>
    <template v-if="model">
      <div class="single-value">
        <flex-row gap center>
          <flex-cell>{{ singleLabel }}</flex-cell>
          <flex-cell shrink>
            <ux-button size="sm" icon @click="clear">
              <ux-icon icon="fa-times" />
            </ux-button>
          </flex-cell>
        </flex-row>
      </div>
    </template>
    <template v-else>
      <value-search
        :options="options"
        :async-options="shouldPreload ? undefined : asyncOptionsURL"
        :server-filtered="field.serverFiltered"
        v-model="model"
        :multiple="false"
        :placeholder="placeholder"
        :list="false"
      />
    </template>
  </template>
</template>

<script>
import InputMixin from "./input-mixin";
import ValueSearch from "./value-search.vue";

export default {
  components: {
    ValueSearch,
  },
  props: {
    modelValue: {
      type: [String, Array],
    },
  },
  mixins: [InputMixin],
  methods: {
    removeValue(index) {
      const sliced = this.model.slice();
      sliced.splice(index, 1);
      this.model = sliced;
      this.touch();
    },
    clear() {
      this.model = undefined;
      this.touch();
    },
  },
  computed: {
    shouldPreload() {
      return !!this.field.preloadOptions;
    },
    asyncOptionsURL() {
      // Only use explicit asyncOptions URL for value-search.
      // dynamicOptions (smartlist) is not relevant for plain values.
      const url = this.field.asyncOptions;
      if (url && String(url).trim().length) {
        return url;
      }
    },
    hasAsyncOptions() {
      // Only preload from the URL on mount when preloadOptions is set.
      // Otherwise the inner value-search component handles
      // per-keystroke server search via asyncOptions.
      if (this.asyncOptionsURL && this.shouldPreload) {
        return true;
      }
      return false;
    },
    optionTitleLookup() {
      return (this.options || []).reduce(function (hash, o) {
        const key = o.value || o._id || o;
        hash[key] = o.title || o.name || o.label || key;
        return hash;
      }, {});
    },
    singleLabel() {
      const val = this.model?.[0];
      return this.optionTitleLookup[val] || val;
    },
    modelDisplay() {
      const lookup = this.optionTitleLookup;
      return (this.model || []).map(function (val) {
        return lookup[val] || val;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select-tags {
  display: block;
  margin-bottom: 0.5em;

  .select-tag {
    display: block;
    padding: 0.5em 0.5em 0.5em 1em;
    border-radius: 2em;
    margin-bottom: 0.3em;
    line-height: 1;
    font-size: 0.9em;
    border: 1px solid color-mix(in lab, currentColor 18%, transparent);

    a {
      cursor: pointer;
      opacity: 0.3;
      display: inline-block;

      &:hover {
        opacity: 1;
      }
    }
  }
}

.single-value {
  padding: 0.5em 0.5em 0.5em 1em;
  border-radius: 0.3em;
  line-height: 1;
  font-size: 0.9em;
  border: 1px solid color-mix(in lab, currentColor 18%, transparent);
}
</style>
